import { render, staticRenderFns } from "./ui-tag.vue?vue&type=template&id=a156e67a&scoped=true"
import script from "./ui-tag.vue?vue&type=script&lang=js"
export * from "./ui-tag.vue?vue&type=script&lang=js"
import style0 from "./ui-tag.vue?vue&type=style&index=0&id=a156e67a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a156e67a",
  null
  
)

export default component.exports